export default __webpack_public_path__ + "static/media/new-replay.5a73ba15.svg";